export interface DemoProfile {
  planId: string;
  companyId?: string;
}

const KEY = "fp_demo_profile";

export function getDemoProfile(): DemoProfile | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.planId === "string") {
      return { planId: parsed.planId, companyId: parsed.companyId ?? undefined };
    }
    return null;
  } catch { return null; }
}

export function saveDemoProfile(p: DemoProfile): void {
  try { localStorage.setItem(KEY, JSON.stringify(p)); } catch {}
}

export function clearDemoProfile(): void {
  try { localStorage.removeItem(KEY); } catch {}
}
